import { css } from '@emotion/react';
import { color } from './color';

// ボタンをクリックした場合に波紋のアニメーションを表示する
export const BtnClickAnimation = css`
  position: relative;
  overflow: hidden;
  user-select: none;
  text-decoration: none;
  outline: none;

  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: radial-gradient(circle, #fff 10%, transparent 10%) no-repeat 50%;
    transform: scale(10, 10);
    opacity: 0;
    transition: transform 0.3s, opacity 1s;
  }

  &:active::after {
    transform: scale(0, 0);
    transition: 0s;
    opacity: 0.3;
  }
`;

// 更新中三点アニメーション
export const ThreeDotsAnimation = css`
  position: relative;
  width: 3px;
  height: 3px;
  border-radius: 1.5px;
  background-color: rgba(170, 170, 170, 1);

  animation: dot-flashing 2s infinite ease-in-out;
  animation-delay: 0.5s;
  opacity: 1;

  &::before,
  &::after {
    position: absolute;
    content: '';
    width: 3px;
    height: 3px;
    border-radius: 1.5px;
    background-color: rgba(170, 170, 170, 1);
    animation: dot-flashing 2s infinite ease-in-out;
    opacity: 1;
  }

  &::before {
    left: -5px;
    animation-delay: 0s;
  }

  &::after {
    right: -5px;
    animation-delay: 1s;
  }

  @keyframes dot-flashing {
    0%,
    100% {
      // #AAAAAA : opacityだと疑似要素が影響を受けるのでrgbaにする
      background-color: rgba(170, 170, 170, 1);
    }

    40%,
    60% {
      background-color: rgba(170, 170, 170, 0.2);
    }
  }
`;
